/*
 * @Author: your name
 * @Date: 2020-09-09 09:08:06
 * @LastEditTime: 2022-02-16 09:04:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\pages\home\index.ts
 */
import Vue from 'vue'
import Index from './index.vue'
import { Col, Card, Row, Backtop, Steps, Step, Button, Dialog, Icon, Input, Menu, MenuItem, Popover, Message } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/styles/index.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'
import 'swiper/css/swiper.css'
Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper)

Vue.use(Col)
Vue.use(Row)
Vue.use(Card)
Vue.use(Backtop)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Button)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(Input)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Popover)
Vue.prototype.$message = Message

new Vue({
  render: h => h(Index)
}).$mount('#app')
